export const platforms = {
  SALESFORCE: 'salesforce',
};
